import ContentLayout from "../components/layout/ContentLayout";
import {
  Form,
  Input,
  Upload,
  message,
  Row,
  Col,
  Card,
  Typography,
  Space,
} from "antd";
import { InboxOutlined, DeleteOutlined } from "@ant-design/icons";
import Button from "../components/Button";
import MyModal from "../components/MyModal";
import { useRef, useState } from "react";
import { useSelector } from "react-redux";
import { createReward } from "../actions/acc_actions";
import { useTranslation } from "react-i18next";

const { Dragger } = Upload;
const { Title } = Typography;

export default function RewardsForm() {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const [fileList, setFileList] = useState([]);
  const [previewUrl, setPreviewUrl] = useState(null);
  const modalRef = useRef();
  const businessName = useSelector((state) => state.account.name);
  const businessUrn = useSelector((state) => state.account.businessUrn);

  // 🖼️ Handle image selection with preview
  const handleChange = ({ fileList }) => {
    setFileList(fileList);

    if (fileList.length > 0) {
      const file = fileList[0].originFileObj || fileList[0];
      setPreviewUrl(URL.createObjectURL(file));
    } else {
      handleRemove();
    }
  };

  const handleRemove = () => {
    setFileList([]);
    setPreviewUrl(null);
    form.setFieldsValue({ file: null });
  };

  const onFinish = async (values) => {
    try {
      const formData = new FormData();
      formData.append("businessUrn", businessUrn);
      formData.append("name", values.name);

      if (values.file) {
        formData.append("file", values.file);
      }

      await createReward(formData);
      modalRef.current.showModal();
      form.resetFields();
      handleRemove();
    } catch (err) {
      message.error(
        err?.response?.data?.error?.message || "Something went wrong!",
      );
    }
  };

  return (
    <ContentLayout
      header={
        <>
          <h1>
            {t("welcome")} <br /> <span>{businessName}</span>
          </h1>
          <p className="content_layout-subtitle">{t("create_stamp_reward")}</p>
        </>
      }
    >
      ...
      <Card
        title={<Title level={4}>{t("create_new_reward")}</Title>}
        bordered={false}
        style={{
          borderRadius: 16,
          boxShadow: "0 4px 20px rgba(0,0,0,0.05)",
          padding: "24px",
        }}
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
          requiredMark={false}
        >
          <Form.Item
            name="name"
            label={t("reward_name")}
            tooltip={t("reward_name_tooltip")}
            rules={[
              { required: true, message: t("input_reward_name_required") },
            ]}
          >
            <Input placeholder={t("reward_name_placeholder")} />
          </Form.Item>

          <Form.Item
            label={t("reward_image_optional")}
            name="file"
            valuePropName="file"
            getValueFromEvent={(e) =>
              e?.fileList?.[0]?.originFileObj || e?.fileList?.[0]
            }
          >
            {!previewUrl ? (
              <Dragger
                fileList={fileList}
                beforeUpload={() => false}
                onChange={handleChange}
                maxCount={1}
                accept="image/*"
                multiple={false}
                style={{
                  borderRadius: 12,
                  backgroundColor: "#fafafa",
                  padding: "20px 0",
                }}
              >
                <p className="ant-upload-drag-icon">
                  <InboxOutlined style={{ color: "#1890ff" }} />
                </p>
                <p className="ant-upload-text">{t("click_drag_upload")}</p>
                <p className="ant-upload-hint" style={{ color: "#888" }}>
                  {t("upload_hint")}
                </p>
              </Dragger>
            ) : (
              <div
                style={{
                  textAlign: "center",
                  border: "1px dashed #d9d9d9",
                  borderRadius: 12,
                  padding: 16,
                  background: "#fafafa",
                }}
              >
                <img
                  src={previewUrl}
                  alt="Preview"
                  style={{
                    maxWidth: "100%",
                    borderRadius: 8,
                    marginBottom: 16,
                  }}
                />
                <Space>
                  <Button
                    danger
                    icon={<DeleteOutlined />}
                    onClick={handleRemove}
                  >
                    {t("remove")}
                  </Button>
                </Space>
              </div>
            )}
          </Form.Item>

          <Form.Item style={{ textAlign: "center", marginTop: 24 }}>
            <Button htmlType="submit" type="primary">
              {t("create_reward")}
            </Button>
          </Form.Item>
        </Form>
      </Card>
      ...
      <MyModal
        ref={modalRef}
        title={t("add_reward_success")}
        message={t("reward_success_message")}
        imageSrc="/assets/images/modal/star.png"
        confirmText={t("back_to_rewards")}
        navigatePath="/rewards"
      />
    </ContentLayout>
  );
}
